export default {
  // Errors
  TransportDateMustBeAfterDeliveryDate: 'Transport date must be after delivery date',
  insufficientStock: 'Insufficient stock',

  // Words
  actualWeight: 'Actual weight',
  address: 'Address',
  addTransportLicense: 'Add transport license',
  allowedUnloadTime: 'Allowed unload time',
  allowedUnloadTimeFrom: 'Allowed unload time (from)',
  allowedUnloadTimeTo: 'Allowed unload time (to)',
  bundleCount: 'Bundle count',
  buyerName: 'Buyer name',
  cargoRow: 'Cargo row',
  carInfo: 'Car info',
  city: 'City',
  date: 'Date',
  deliveryInfo: 'Delivery info',
  disciplinaryNumber: 'Disciplinary number',
  driverInfo: 'Driver info',
  emptyWeighingHours: 'Empty weighing hours',
  emptyWeighingMinutes: 'Empty weighing minutes',
  emptyWeight: 'Empty weight',
  from: 'From',
  fromDate: 'From date',
  fullWeighingHours: 'Full weighing hours',
  fullWeighingMinutes: 'Full weighing minutes',
  fullWeight: 'Full weight',
  inventorySignature: 'Inventory signature',
  iran: 'Iran',
  issuePlace: 'Issue place',
  licenseNumber: 'License number',
  licenseValidity: 'License validity',
  loadingPlaceInfo: 'Loading place info',
  personalTransport: 'Personal transport',
  preNumber: 'Pre number',
  productDescription: 'Product description',
  province: 'Province',
  recipientCellNumber: 'Recipient cell number',
  recipientDescription: '',
  recipientInfo: 'Recipient info',
  recipientName: 'Recipient name',
  recipientNationalCode: 'Recipient national code',
  recipientPhoneNumber: 'Recipient phone number',
  recipientPrePhoneNumber: 'Recipient pre phone number',
  recipientSignature: 'Recipient signature',
  requestAmount: 'Request amount',
  requestSubmissionDate: 'Date of request submission',
  smartNumber: 'Smart number',
  to: 'To',
  toDate: 'To date',
  trailerName: 'Trailer name',
  transport: 'Transport',
  transportCompanyInfo: 'Transportation company info',
  transportRequest: 'Transportation request',
  transportRequestDetails: 'Transportation request number {number} details',
  transportRequests: 'Transportation requests',
  transportRequestSubmitted: 'Transportation request submitted',
  transportByCourier: 'Transport by {courier}',
  transportDate: 'Transport date',
  transportDone: 'Transport done',
  transporterCellNumber: 'Transporter cell number',
  transporterFirstName: 'Transporter first name',
  transporterInfo: 'Transporter info',
  transporterLastName: 'Transporter last name',
  transporterNationalCode: 'Transporter national code',
  transporterPhoneNumber: 'Transporter phone number',
  transporterPrePhoneNumber: 'Transporter pre phone number',
  transportLicense: 'Transport license',
  transportLicenses: 'Transport licenses',
  transportLicenseSaved: 'Transport license saved',
  transportRecord: 'Transport record',
  transportRecordSaved: 'Transport record saved',
  transportRequestOf: 'Transport request of',
  transportType: 'Transport type',
  unloadPlace: 'Unload place info',
  unloadPlaceName: 'Unload place name',
  unloadTime: 'Unload time',
  weighbridgeReceipt: 'Weighbridge receipt',
  weighingHour: 'Weighing hour',
  weighingInfo: 'Weighing info',
  zipCode: 'Zip code',
  licenseRecord: 'License record',
  statuses: {
    tranporting: 'Tranporting',
    transported: 'Transported'
  }
}
